// extracted by mini-css-extract-plugin
module.exports = {"subscribe":"Subscribe_subscribe__26GvW","header":"Subscribe_header__51Gre"};